import Pager from '@/shared/pager/pager';

export default {
  build: () => {
    const keysToSearch = [
      'name',
    ];

    const exportDefinitions = [
      { value: 'id', label: 'Id' },
      { value: 'name', label: 'Name' },
      { value: 'lastName', label: 'LastName' },
      { value: 'email', label: 'Email' },
      { value: 'phone', label: 'Phone' },
      { value: 'club.name', label: 'Club' },
      { value: 'created', label: 'Created at' },
      { value: 'modified', label: 'Updated at' }
    ];

    return new Pager(keysToSearch, exportDefinitions);
  }
};



// WEBPACK FOOTER //
// ./src/entities/manager/manager-pager.js